import { EncryptStorage } from 'encrypt-storage';
import { secretKey } from '@/config.js';

// Example of secret_key variable in an .env file
// const encryptStorage = new EncryptStorage(process.env.SECRET_KEY, options);
export const encryptStorage = new EncryptStorage(secretKey);
